import { render } from "./LoginTaxis.vue?vue&type=template&id=24f32418&scoped=true"
import script from "./LoginTaxis.vue?vue&type=script&lang=js"
export * from "./LoginTaxis.vue?vue&type=script&lang=js"

import "./LoginTaxis.vue?vue&type=style&index=0&id=24f32418&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f32418"]])

export default __exports__